import React, {useState} from 'react';

import ChooseLayoutDimensions from 'components/layout_and_quote_builder/options/ChooseLayoutDimensions.jsx';
import ChooseNumXNumY from 'components/layout_and_quote_builder/options/ChooseNumXNumY.jsx';
import ChooseUserOptions from 'components/layout_and_quote_builder/options/ChooseUserOptions.jsx';
import RedrawLayoutButton from 'components/layout_and_quote_builder/options/RedrawLayoutButton.jsx';
import ChooseAdvancedOptions from 'components/layout_and_quote_builder/options/ChooseAdvancedOptions.jsx';

const LayoutRedrawForm = ({item, setRedrawRequested, recoveryApplyMethods, redrawInProgress, disabled, formRef,
  layoutDimensionType,
  materialLayoutDimensionId,
  layoutDimensionDefaultValues,
  layoutDimensionPublicSetter,
  layoutDimensionSmallerSubSetOf,
  layoutDimensionTitle
}) => {
  const [options, setOptions] = useState({});

  return (
    <>
      <div>
        {!disabled && (<form ref={formRef} id={`form_${item.uuid}`}>

          <ChooseLayoutDimensions item={item}
            title={layoutDimensionTitle}
            defaultValues={layoutDimensionDefaultValues}
            publicSetter={layoutDimensionPublicSetter}
            smallerSubSetOf={layoutDimensionSmallerSubSetOf}
            hideCustom={true}
          />

          <ChooseNumXNumY item={item} />
          <ChooseUserOptions item={item} member_id={item.id} member_klass={item.klass} recoveryApplyMethods={recoveryApplyMethods} />
          <ChooseAdvancedOptions item={item} member_id={item.id} member_klass={item.klass} recoveryApplyMethods={recoveryApplyMethods} />

          <RedrawLayoutButton uuid={item.uuid} redrawInProgress={redrawInProgress} setRedrawRequested={setRedrawRequested} />
        </form>)}

        {disabled && <div className="disabledForm">
          <ChooseLayoutDimensions defaultValues={{}} />
          <ChooseNumXNumY/>
          <RedrawLayoutButton disabled />
          <br />
          <br />
        </div>}
        <br />
      </div>
    </>
  )
};

export default LayoutRedrawForm;
